import store from "../store"

export function updateTitle(title?: string) {
    const loja = store.getters["AppConfig/getConfigsVisuais"].visual?.nomeLoja;
    if (!loja) {
        document.title = "Portal de pedidos";
        return;
    }
    const parsedTitle = title ? ` - ${title}` : "";

    document.title = `${loja}${parsedTitle}`;

}